import { classNames, getLinkProps } from '~/lib';
import { Heading, Link } from '..';
import { ArrowLeft, ArrowRight } from '../Icons';

interface PageNavigationProps {
  className?: string;
  next?: any;
  previous?: any;
  index?: boolean;
}

export const PageNavigation = ({
  className,
  next,
  previous,
  index,
}: PageNavigationProps) => {
  const nextUrl = next
    ? `/${getLinkProps(next?.full_slug).replace('guides/', '')}`
    : '/contact';
  const previousUrl = `/${getLinkProps(previous?.full_slug).replace(
    'guides/',
    '',
  )}`;

  return (
    <div
      className={classNames(
        'flex flex-col-reverse md:flex-row w-full justify-center',
        className,
      )}
    >
      <Link
        href={previousUrl}
        className={classNames(
          'py-6 px-7 rounded-lg flex justify-between w-full hover:shadow-dark-xl group transition-all bg-dark-grey-500',
          'hover:bg-dark-grey-900',
        )}
      >
        <div
          className={classNames(
            'rounded-full border-2 border-grey-400 h-10 w-10 p-3 flex items-center justify-center text-white self-center mr-4',
            'group-hover:border-brand',
          )}
        >
          <ArrowLeft className="h-full w-full" />
        </div>
        <div className="text-right">
          <Heading
            as="h6"
            variant="h6"
            className={classNames(
              'text-xs text-white',
              'group-hover:text-brand',
            )}
          >
            previous
          </Heading>
          <p
            className={classNames(
              'text-lg mt-1 text-white',
              'group-hover:text-brand',
            )}
          >
            {previous?.content?.title}
          </p>
        </div>
      </Link>
      <Link
        href={nextUrl}
        className={classNames(
          'mb-8 md:mb-0 md:ml-8 py-6 px-7 rounded-lg flex justify-between w-full hover:shadow-dark-xl group transition-all',
          index ? 'bg-brand' : 'bg-dark-grey-500 hover:bg-dark-grey-900',
        )}
      >
        <div>
          <Heading
            as="h6"
            variant="h6"
            className={classNames(
              'text-xs',
              index
                ? 'group-hover:text-grey-900'
                : 'group-hover:text-brand text-white',
            )}
          >
            {next ? 'Next up' : 'Contact us'}
          </Heading>
          <p
            className={classNames(
              'text-lg mt-1',
              index
                ? 'group-hover:text-grey-900'
                : 'group-hover:text-brand text-white',
            )}
          >
            {next
              ? next.content?.title
              : 'Get in touch to discover how we can help'}
          </p>
        </div>

        <div className="self-center ml-4">
          <div
            className={classNames(
              'rounded-full border-2 border-grey-400 h-10 w-10 p-3 flex items-center justify-center text-white',
              index ? 'text-grey-900' : 'group-hover:border-brand',
            )}
          >
            <ArrowRight className="h-full w-full" />
          </div>
        </div>
      </Link>
    </div>
  );
};
